/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceFeatureFlagsWithDefaults extends models.FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return ComplianceFeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<ComplianceFeatureFlagsWithDefaults>): ComplianceFeatureFlagsWithDefaults {
        let obj = Object.assign(new ComplianceFeatureFlagsWithDefaults(), model);
        ComplianceFeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceFeatureFlagsWithDefaults>): ComplianceFeatureFlagsWithDefaults {
        if (!model) return null;
        return ComplianceFeatureFlagsWithDefaults.newInstance(<ComplianceFeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceFeatureFlagsWithDefaults) {
        if (!obj) return;

        models.ComplianceFeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceFeatureFlagsWithDefaults): boolean {
        if (models.FeatureFlagsWithDefaults.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ComplianceFeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag's default value
     */
    comp_2504_a_test_flag: boolean = false;

    /**
     * Flag's default value
     */
    comp_2603_a_compliance_standard_simplified: boolean = true;

}
